import React, { useState } from "react";
import {
  Grid,
  Typography,
  Box,
  Card,
  CircularProgress,
  Button,
} from "@mui/material";
import { CloudUpload } from "@mui/icons-material";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import useSnackbar from "../../hooks/useSnackbar";
import { baseUrl } from "../../config/api-config";

export default function UploadFilesAttachment() {
  const [loader, setLoader] = useState(false);
  const { data: user } = useSelector((state) => state.user);
  const snackbar = useSnackbar();
  const navigate = useNavigate();
  const [selectedFile, setSelectedFile] = useState({
    name: "",
    type: "",
    size: "",
    lastModifiedDate: "",
  });
  const [isSelected, setIsSelected] = useState(false);

  const [progress, setProgress] = useState(0);
  const submit = async () => {
    const formData = new FormData();
    if (selectedFile.name === "") {
      return snackbar.showError("Attachment can't be empty");
    }
    formData.append("file", selectedFile.file); // Use the file property
    setLoader(true);
    await uploadAttachment(formData, user.token);
    setLoader(false);
    navigate("/upload-files-list");
  };

  const uploadAttachment = (formData, token) => {
    return new Promise((resolve, reject) => {
      const xhr = new XMLHttpRequest();

      xhr.upload.addEventListener("progress", (event) => {
        if (event.lengthComputable) {
          const percentCompleted = Math.round(
            (event.loaded * 100) / event.total
          );
          setProgress(percentCompleted);
        }
      });

      xhr.onload = function () {
        if (xhr.status === 200) {
          const response = JSON.parse(xhr.response);
          const data = response; // Modify this line to extract the desired data
          snackbar.showSuccess(data.msg);
          resolve(data);
        } else {
          const response = JSON.parse(xhr.response);
          const data = response; // Modify this line to extract the desired data
          snackbar.showError(data.msg);
          // Reset states here
          setLoader(false);
          setProgress(0);
          reject(xhr.statusText);
        }
      };

      xhr.onerror = function () {
        snackbar.showError("An error occurred while uploading the file.");
      };
      xhr.open("POST", `${baseUrl}/upload`);
      xhr.setRequestHeader("Authorization", `Bearer ${token}`);
      xhr.send(formData);
    });
  };

  const handleDrop = (event) => {
    event.preventDefault();
    event.stopPropagation();
    handleSelectedFiles(event.dataTransfer.files[0]); // Pass the first file
  };
  const handleDragEnter = (event) => {
    event.preventDefault();
    event.stopPropagation();
    // Add styling or visual feedback to indicate potential drop target
  };

  const handleDragOver = (event) => {
    event.preventDefault();
    event.stopPropagation();
    // Add styling or visual feedback to indicate potential drop target
  };

  const handleDragLeave = (event) => {
    event.preventDefault();
    event.stopPropagation();
    // Remove any styling or visual feedback used to indicate potential drop target
  };
  const handleSelectedFiles = (file) => {
    if (!file) {
      setIsSelected(false);
      setSelectedFile({});
      return;
    }
    setSelectedFile({
      name: file.name,
      type: file.type,
      size: file.size,
      lastModifiedDate: file.lastModifiedDate,
      file: file, // Store the File object
    });
    setIsSelected(true);
  };

  const changeHandler = (event) => {
    const file = event.target.files[0];
    if (!file) {
      setIsSelected(false);
      setSelectedFile();
      return;
    }
    setSelectedFile({
      name: file.name,
      type: file.type,
      size: file.size,
      lastModifiedDate: file.lastModifiedDate,
      file: file, // Store the File object
    });
    setIsSelected(true);
  };

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={12}>
        <Card sx={{ boxShadow: "none !important" }}>
          <div
            className="upload-files-container"
            onDragEnter={handleDragEnter}
            onDragOver={handleDragOver}
            onDragLeave={handleDragLeave}
            onDrop={handleDrop}
          >
            <div className="drag-file-area">
              <div className="upload-icon upload-center">
                <CloudUpload sx={{ fontSize: 40, color: "#08459c" }} />
              </div>
              <h6 className="dynamic-message upload-center">Drag & Drop</h6>

              <Grid item xs={12} md={12}>
                <Button
                  variant="contained"
                  component="label"
                  fullWidth
                  sx={{
                    mb: 2,
                    width: "170px",
                    height: "32px",
                    backgroundColor: "#009de2",
                  }}
                >
                  Choose File
                  <input
                    type="file"
                    name="file"
                    style={{ display: "none" }}
                    onChange={changeHandler}
                  />
                </Button>
              </Grid>
              {isSelected && (
                <Box>
                  <Typography
                    sx={{ whiteSpace: "pre-wrap", wordWrap: "break-word" }}
                  >
                    Filename: {selectedFile.name}
                  </Typography>
                  <Typography>Filetype: {selectedFile.type}</Typography>
                  <Typography>
                    Size in bytes: {formatFileSize(selectedFile.size)}
                  </Typography>
                  <Typography>
                    Last modified date:{" "}
                    {selectedFile.lastModifiedDate.toLocaleDateString()}
                  </Typography>
                </Box>
              )}
              {loader === false ? (
                <Button
                  variant="contained"
                  onClick={submit}
                  sx={{ backgroundColor: "#009de2" }}
                >
                  Add Attachments
                </Button>
              ) : (
                <Box sx={{ mt: 2 }}>
                  {/* Display progress with percentage */}
                  <CircularProgress variant="determinate" value={progress} />
                  <Typography variant="body2" align="center">
                    {progress}%
                  </Typography>
                </Box>
              )}
            </div>
          </div>
        </Card>
      </Grid>
    </Grid>
  );
}
function formatFileSize(value) {
  const units = ["B", "KB", "MB", "GB", "TB"];
  let size = parseFloat(value); // Convert to a number using parseFloat
  let unitIndex = 0;

  while (size >= 1024 && unitIndex < units.length - 1) {
    size /= 1024;
    unitIndex++;
  }

  const decimalSize = size.toFixed(1);
  const unit = units[unitIndex];

  return `${decimalSize} ${unit}`;
}
